import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/maps")({
  // Component moved to $orgSlug.admin.maps.lazy.tsx for code splitting
});
